import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { deleteDataEntryDraft, fetchDataEntryDrafts } from '../services/dataEntryDrafts';

export default function DataEntryDraftList({ studentId, onResume, onDeleted, refreshKey = 0, disabled = false }: any) {
  const { user } = useAuth();
  const [drafts, setDrafts] = useState<any>([]);
  const [loading, setLoading] = useState<any>(true);
  const [error, setError] = useState<any>('');
  const [deleting, setDeleting] = useState<any>(null);
  const [revision, setRevision] = useState<any>(0);
  const schoolId = user?.school_id;
  const userId = user?.user_id ?? user?.id;

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setDrafts([]);
    setError('');
    if (!schoolId) {
      setError('Select a school to load your saved drafts.');
      setLoading(false);
      return undefined;
    }
    fetchDataEntryDrafts(schoolId, studentId)
      .then(data => { if (!cancelled) setDrafts(data); })
      .catch(loadError => { if (!cancelled) setError(loadError.message || 'Could not load saved drafts.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [schoolId, userId, studentId, refreshKey, revision]);

  const remove = async id => {
    setDeleting(id);
    setError('');
    try {
      await deleteDataEntryDraft(id);
      setDrafts(previous => previous.filter(draft => draft.id !== id));
      onDeleted?.(id);
    } catch (deleteError: any) {
      setError(deleteError.message || 'Could not delete the draft.');
    } finally {
      setDeleting(null);
    }
  };

  return (
    <details className="sge-drafts">
      <summary>Saved drafts ({drafts.length})</summary>
      <p>Private to your account. Drafts do not affect student progress until published.</p>
      {loading && <p>Loading drafts...</p>}
      {error && <div role="alert">{error} <button type="button" onClick={() => setRevision(value => value + 1)}>Retry loading drafts</button></div>}
      {!loading && !error && !drafts.length && <p>No saved drafts.</p>}
      {drafts.map(draft => (
        <div key={draft.id} className="sge-draft-row">
          <span>
            <strong>{draft.form.titleOfDataPoint || draft.form.selections.map(selection => selection.code).join(', ')}</strong>
            {' — '}{draft.form.selectedStudents.length} student(s), {draft.form.selections.length} standard(s)
            {' — '}{new Date(draft.updated_at).toLocaleString()}
          </span>
          <button type="button" disabled={disabled || deleting != null} onClick={() => onResume(draft)}>Resume draft</button>
          <button type="button" disabled={disabled || deleting != null} onClick={() => {
            if (window.confirm('Delete this saved draft? This cannot be undone.')) remove(draft.id);
          }}>{deleting === draft.id ? 'Deleting...' : 'Delete draft'}</button>
        </div>
      ))}
    </details>
  );
}
